import { BaseFetch } from "../main-model"
export default class OnetModel extends BaseFetch {
    getOnetBy = (data) =>
        this.authFetch({
            url: "onet/getOnetBy",
            method: "POST",
            body: JSON.stringify(data),
        })
    getOnetById = (data) =>
        this.authFetch({
            url: "onet/getOnetById",
            method: "POST",
            body: JSON.stringify(data),
        })
    updateOnetById = (data) =>
        this.authFetch({
            url: "onet/updateOnetById",
            method: "POST",
            body: JSON.stringify(data),
        })
    insertOnet = (data) =>
        this.authFetch({
            url: "onet/insertOnet",
            method: "POST",
            body: JSON.stringify(data),
        })
    deleteOnetById = (data) =>
        this.authFetch({
            url: "onet/deleteOnetById",
            method: "POST",
            body: JSON.stringify(data),
        })
}
